export const isProduction = process.env.NEXT_PUBLIC_LISTERI_ENV === 'production'
export const isDevelopment = process.env.NEXT_PUBLIC_LISTERI_ENV === 'development'
